export enum DNIType {
  CC = 'CC',
  PASSPORT = 'PASSPORT',
  CE = 'CE',
  CPEP = 'CPEP',
  NIT = 'NIT',
  PA = 'PASSPORT',
}

export const getDNIType = (type: string) => {
  const keys = Object.keys(DNIType);
  const found = keys.find((key) => key === type);
  if (found) {
    return DNIType[found];
  }
  throw Error('Unsuported dni type');
};
